<app-navbar title="Ogólne nagłówki">
	<div class="button-row">
		<button class="me-4" mat-raised-button color="primary" *ngIf="editable" (click)="checkForms()">Zapisz</button>
		<button mat-raised-button color="primary" class="me-4" *ngIf="!editable" (click)="editUnlock()">Edycja</button>
		<button class="me-4" mat-raised-button color="warn" routerLink="../">
			<i class="fas fa-chevron-left me-1"></i>Powrót
		</button>
	</div>
</app-navbar>
<div class="container mt-4">
	<div class="d-flex justify-content-between">
		<div class="form-floating mb-3 w-45">
			<ng-select
				name="use"
				[readonly]="!editable"
				[(ngModel)]="data.use"
				placeholder="Użycie"
				[clearable]="false"
				[searchable]="false"
			>
				<ng-option *ngFor="let item of use" [value]="item.code">{{ item.name }}</ng-option>
			</ng-select>
		</div>
		<div class="form-floating mb-3 w-45">
			<ng-select
				placeholder="Wybierz nagłówek"
				[(ngModel)]="data.descriptionHeader.name"
				[clearable]="false"
				[readonly]="!editable"
				(change)="selectHeader($event)"
			>
				<ng-option *ngFor="let item of descriptionHeaders" [value]="item">{{ item.name }}</ng-option>
			</ng-select>
		</div>
	</div>
	<app-editor [disabled]="!editable" [(value)]="data.description"></app-editor>
</div>
